import React, { useState, useEffect } from "react";

import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faLinkedin,
  faGithub,
  faHackerrank,
  faInstagram,
} from "@fortawesome/free-brands-svg-icons";

import Logo from "../components/common/Logo";
import Footer from "../components/common/Footer";
import NavBar from "../components/common/NavBar";
import Skills from "../components/home/Skills";
import AllEducationAndWork from "../components/home/AllEducationAndWork";
import INFO from "../data/user";

import "./styles/home.css";

const Home = () => {
  const [stayLogo, setStayLogo] = useState(false);
  const [logoSize, setLogoSize] = useState(80);
  const [oldLogoSize, setOldLogoSize] = useState(80);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      let scroll = Math.round(window.pageYOffset, 2);

      let newLogoSize = 80 - (scroll * 4) / 10;

      if (newLogoSize < oldLogoSize) {
        if (newLogoSize > 40) {
          setLogoSize(newLogoSize);
          setOldLogoSize(newLogoSize);
          setStayLogo(false);
        } else {
          setStayLogo(true);
        }
      } else {
        setLogoSize(newLogoSize);
        setStayLogo(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [logoSize, oldLogoSize]);

  const logoStyle = {
    display: "flex",
    position: stayLogo ? "fixed" : "relative",
    top: stayLogo ? "3vh" : "auto",
    zIndex: 999,
    border: stayLogo ? "1px solid white" : "none",
    borderRadius: stayLogo ? "50%" : "none",
    boxShadow: stayLogo ? "0px 4px 10px rgba(0, 0, 0, 0.25)" : "none",
  };

  return (
    <>
      <div className="page-content">
        <NavBar active="home" />
        <div className="content-wrapper">
          <div className="homepage-logo-container">
            <div style={logoStyle}>
              <Logo width={logoSize} link={false} />
            </div>
          </div>

          <div className="homepage-container">
            <div className="homepage-first-area">
              <div className="homepage-first-area-left-side">
                <h1 className="title homepage-title">{INFO.homepage.title}</h1>

                <p className="subtitle homepage-subtitle">
                  {INFO.homepage.description}
                </p>
              </div>

              <div className="homepage-first-area-right-side">
                <div className="homepage-image-container">
                  <div className="homepage-image-wrapper">
                    <img
                      src={require("../assets/home.jpg")}
                      alt="Akash Dandriyal"
                      className="homepage-image"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="homepage-socials">
              <a
                href={INFO.socials.github}
                target="_blank"
                rel="noreferrer"
                title="GitHub"
              >
                <FontAwesomeIcon
                  icon={faGithub}
                  className="homepage-social-icon"
                />
              </a>
              <a
                href={INFO.socials.linkedin}
                target="_blank"
                rel="noreferrer"
                title="LinkedIn"
              >
                <FontAwesomeIcon
                  icon={faLinkedin}
                  className="homepage-social-icon"
                />
              </a>
              <a
                href={INFO.socials.hackerRank}
                target="_blank"
                rel="noreferrer"
                title="HackerRank"
              >
                <FontAwesomeIcon
                  icon={faHackerrank}
                  className="homepage-social-icon"
                />
              </a>
              <a
                href={INFO.socials.instagram}
                target="_blank"
                rel="noreferrer"
                title="Instagram"
              >
                <FontAwesomeIcon
                  icon={faInstagram}
                  className="homepage-social-icon"
                />
              </a>
              <a
                href={`mailto:${INFO.main.email}`}
                target="_blank"
                rel="noreferrer"
                title="Email"
              >
                <FontAwesomeIcon
                  icon={faEnvelope}
                  className="homepage-social-icon"
                />
              </a>
            </div>

            <div className="homepage-skills">
              <h2>My Skills</h2>
              <Skills />
            </div>

            <div className="homepage-education">
              <h2>Education</h2>
              <AllEducationAndWork props={INFO.education} type="education" />
            </div>

            <div className="homepage-works">
              <h2>Where I’ve Worked</h2>
              <AllEducationAndWork props={INFO.work} type="work" />
            </div>

            <div className="page-footer">
              <Footer />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Home;
